/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Placeholder } from './Placeholder';
import type { TemplateAttachment } from './TemplateAttachment';
export type NotificationTemplate = {
    notification: NotificationTemplate.notification;
    content: string;
    placeholders: Array<Placeholder>;
    attachments: Array<TemplateAttachment>;
};
export namespace NotificationTemplate {
    export enum notification {
        CLIENT_INVITATION = 'client-invitation',
        CLIENT_WELCOME = 'client-welcome',
        CLIENT_BOOKING_SUCCESS = 'client-booking-success',
        CLIENT_BOOKING_CONFIRMATION = 'client-booking-confirmation',
        CLIENT_BOOKING_BY_THERAPIST = 'client-booking-by-therapist',
        CLIENT_BOOKING_MOVED = 'client-booking-moved',
        CLIENT_BOOKING_REJECTION = 'client-booking-rejection',
        CLIENT_BOOKING_CANCELLATION = 'client-booking-cancellation',
        CLIENT_OUTAGE_FEE_APPLIES = 'client-outage-fee-applies',
        CLIENT_APPOINTMENT_REMINDERS = 'client-appointment-reminders',
        CLIENT_DEACTIVATED = 'client-deactivated',
        CLIENT_KICKED_OUT_BY_THERAPIST = 'client-kicked-out-by-therapist',
        CLIENT_PAYMENT_REQUESTED = 'client-payment-requested',
        CLIENT_PAYMENT_CONFIRMATION = 'client-payment-confirmation',
        CLIENT_PAYMENT_DUE = 'client-payment-due',
        CLIENT_INVOICE_SENT = 'client-invoice-sent',
        CLIENT_INVOICE_WITHDRAWN = 'client-invoice-withdrawn',
        CLIENT_SEMINAR_REGISTRATION_CONFIRMATION = 'client-seminar-registration-confirmation',
        CLIENT_SEMINAR_REGISTRATION_BY_THERAPIST = 'client-seminar-registration-by-therapist',
        CLIENT_SEMINAR_SESSION_REMINDER = 'client-seminar-session-reminder',
        CLIENT_SEMINAR_SESSION_CHANGED = 'client-seminar-session-changed',
        CLIENT_SEMINAR_OCCURRENCE_CANCELLATION = 'client-seminar-occurrence-cancellation',
        CLIENT_SEMINAR_REGISTRATION_CANCELLATION = 'client-seminar-registration-cancellation',
        CLIENT_SEMINAR_REGISTRATION_CANCELLED_BY_CLIENT = 'client-seminar-registration-cancelled-by-client',
        CLIENT_SEMINAR_PAYMENT_CONFIRMATION = 'client-seminar-payment-confirmation',
        CLIENT_SEMINAR_OUTAGE_FEE_APPLIES = 'client-seminar-outage-fee-applies',
        CLIENT_SEMINAR_PAYMENT_REQUESTED = 'client-seminar-payment-requested',
        CLIENT_SEMINAR_PAYMENT_DUE = 'client-seminar-payment-due',
        USER_INVITATION = 'user-invitation',
    }
}

